// extracted by mini-css-extract-plugin
export default {"mapdiv":"MapComponent_mapdiv__u21EP","iframediv":"MapComponent_iframediv__K4EeK"};